module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('ext-link', {
      key: index,
      staticClass: "switcher",
      class: item.classes,
      style: (item.styles),
      attrs: {
        "to": item.to
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.variant,
        "activeColor": _vm.activeColor,
        "selected": item.selected
      }
    }), _c('span', {
      class: ['inner', item.variant],
      style: ({
        color: item.selected ? _vm.activeColor : '#fff'
      })
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b77bd62","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/switcher/Switcher.vue
// module id = 9abfc368af0505463366
// module chunks = 0